<template>
    <div>
        <eod-spread-setting-form
            :entity-id="settingId"
        ></eod-spread-setting-form>
    </div>
</template>

<script>
import EodSpreadSettingForm from '@/components/pages/settings/EodSpreadSettingForm'
import { EOD_SPREAD_SETTING_ID } from '@/api/RestApi/EodSpreadSettingApiClient'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        EodSpreadSettingForm,
    },
    mixins: [dirtyForm],
    data: () => ({
        settingId: EOD_SPREAD_SETTING_ID,
    }),
}
</script>
